import { isDate as Nt } from "./code-utils.js";
export function convertMsToSeconds(e, n = !1) {
  let t = e / 1e3;
  return n && (t = Math.floor(t)), t;
}
export function convertSecondsToMs(e) {
  return 1e3 * e;
}
export function dateFromUnixTimestamp(e) {
  if (null == e) return null;
  const n = parseInt(e.toString());
  return isNaN(n) ? null : new Date(1e3 * n);
}
export function toValidBackendTimeString(e) {
  return null != e && Nt(e) ? e.toISOString().replace(/\.[0-9]{3}Z$/, "") : e;
}
export function rehydrateDateAfterJsonization(e) {
  return null == e || "" === e ? null : new Date(e);
}
export function timestampOrNow(e) {
  return null == e || "" === e ? new Date().valueOf() : e;
}
export function secondsAgo(e) {
  return (new Date().valueOf() - e.valueOf()) / 1e3;
}
export function secondsInTheFuture(e) {
  return (e.valueOf() - new Date().valueOf()) / 1e3;
}
